// extracted by mini-css-extract-plugin
export default {"layout":"b11376d92a _453fac7e00 _8bc6ba6b63","h_slide":"_261a37ef9a","category":"a7d2817c25 d2a24df6b1 d70cfb111c"};